
import VDPopupListbox from "@/components/pickers/VDPopupListbox.vue";
import { ApplicationType, useGetApplicationsQuery } from "@/graphql/types";
import { useResult } from "@vue/apollo-composable";
import { computed, defineComponent, PropType, ref } from "vue";
import { VDPopupListboxClass } from "./VDPopupListbox";
import gql from "graphql-tag";

export default defineComponent({
  components: {
    VDPopupListbox,
  },
  emits: ["addedApplication"],
  props: {
    applicationOptions: {
      type: Array as PropType<ApplicationType[]>,
      default: () => [],
    },
    selectedApplications: {
      type: Array as PropType<ApplicationType[]>,
      default: () => [],
    },
    isApplicationOptionsLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    // VDOM
    const listbox = ref<VDPopupListboxClass>();

    // Refs
    const isEnabled = ref(false);

    return {
      listbox,
      toggle: (event: Event) => {
        isEnabled.value = true;
        listbox.value?.toggle(event);
      },
    };
  },
});
